"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainingChanges = exports.ChangesetState = void 0;
/** Possible Changeset states. */
var ChangesetState;
(function (ChangesetState) {
    /** Changeset instance is created but file is not uploaded. The Changeset creation is not complete. */
    ChangesetState["WaitingForFile"] = "waitingForFile";
    /** The Changeset file is uploaded and creation is complete. */
    ChangesetState["FileUploaded"] = "fileUploaded";
})(ChangesetState = exports.ChangesetState || (exports.ChangesetState = {}));
/** Flags that describe Changeset contents. */
var ContainingChanges;
(function (ContainingChanges) {
    ContainingChanges[ContainingChanges["Regular"] = 0] = "Regular";
    ContainingChanges[ContainingChanges["Schema"] = 1] = "Schema";
    ContainingChanges[ContainingChanges["Definition"] = 2] = "Definition";
    ContainingChanges[ContainingChanges["SpatialData"] = 4] = "SpatialData";
    ContainingChanges[ContainingChanges["SheetsAndDrawings"] = 8] = "SheetsAndDrawings";
    ContainingChanges[ContainingChanges["ViewsAndModels"] = 16] = "ViewsAndModels";
    ContainingChanges[ContainingChanges["GlobalProperties"] = 32] = "GlobalProperties";
})(ContainingChanges = exports.ContainingChanges || (exports.ContainingChanges = {}));
//# sourceMappingURL=ChangesetInterfaces.js.map